import { asAnyOf } from './asAnyOf';
import { asExactly } from './asExactly';
export var asEnum = function (variants, expected) {
    return asAnyOf(variants.map(asExactly), expected);
};
